import React, { useState, useEffect } from 'react'
import { useInput } from '../../hooks/useInput'
import Img from '../general/Image'
import useContent from '../../utils/content'
import { useDataQuery } from '../../hooks/useDataQuery'

export default function Form2() {
  const content = useContent(useDataQuery())
  const numbersArray = new Array(30).fill(0)
  const date = new Date()
  const todayDate = `${date.getFullYear()}-${
    date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1
  }-${date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()}`
  const tomorrowDate = `${date.getFullYear()}-${
    date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1
  }-${date.getDate() + 1 < 10 ? `0${date.getDate() + 1}` : date.getDate() + 1}`

  numbersArray.forEach((element, index) => {
    const count = index + 1

    if (count < 10) {
      numbersArray[index] = `0${count}`
    } else {
      numbersArray[index] = `${count}`
    }
  })

  const { value: arrivalDate, bind: bindArrivalDate } = useInput(todayDate)
  const { value: departureName, bind: bindDepartureName } = useInput(
    tomorrowDate
  )
  // const { value: guestsCount, bind: bindGuestsCount } = useInput(1)

  const [widgetId, setWidgetId] = useState('')
  const [propertyName, setPropertyName] = useState('')

  const handleSubmit = evt => {
    evt.preventDefault()

    const reformatDate = dateString =>
      dateString
        .split('-')
        .reverse()
        .join('-')

    window.open(
      `https://ibe.sabeeapp.com/properties/${propertyName}/?p=${widgetId}&checkin=${reformatDate(
        arrivalDate
      )}&checkout=${reformatDate(departureName)}`
    )
  }

  useEffect(() => {
    let isSubscribed = true
    fetch(content.teaserWidgetUrl)
      .then(response => {
        return response.text()
      })
      .then(resp => {
        if (isSubscribed) {
          setWidgetId(
            resp
              .match(
                /StartBooking[('A-Za-z0-9\!\"\#\$\%\&\'\(\)\*\+\,\-\.\/\:\;\<\>\=\?\@\[\]\{\}\\\\\^\_\`\~')]+/
              )[0]
              .split(/[('')]+/)[1]
          )
          setPropertyName(
            resp
              .match(
                /propertyname = ['A-Za-z\u0400-\u04FF0-9\!\"\#\$\%\&\'\(\)\*\+\,\-\.\/\:\;\<\>\=\?\@\[\]\{\}\\\\\^\_\`\~']+/
              )[0]
              .split(/['']+/)[1]
          )
        }
      })

    return function() {
      isSubscribed = false
    }
  }, [])

  return (
    <>
      <form
        className="teaser_cont_form-normal"
        name="Volter"
        data-netlify="true"
        onSubmit={handleSubmit}
      >
        <div className="teaser_cont_form-normal_block">
          <div className="teaser_cont_form-normal_block_data">
            <span>
              <Img src={content.dataImage} />
              {content.teaserFirstDateName}
            </span>
            <div className="teaser_cont_form-normal_block_data_outside">
              <input name="number" type="date" {...bindArrivalDate} />
              <p>
                {arrivalDate ? (
                  <>
                    <span>{arrivalDate.split('-')[2]}</span>
                    <span>
                      {content.months[new Date(arrivalDate).getMonth()]}
                    </span>
                  </>
                ) : (
                  <>
                    <span>{new Date().getDate()}</span>
                    <span>{content.months[new Date().getMonth()]}</span>
                  </>
                )}
              </p>
            </div>
          </div>
        </div>
        <div className="teaser_cont_form-normal_block">
          <label className="teaser_cont_form-normal_block_data">
            <span>
              <Img src={content.dataImage} />
              {content.teaserLastDateName}
            </span>
            <div className="teaser_cont_form-normal_block_data_outside">
              <input type="date" name="months" {...bindDepartureName} />
              <p>
                {departureName ? (
                  <>
                    <span>{departureName.split('-')[2]}</span>
                    <span>
                      {content.months[new Date(departureName).getMonth()]}
                    </span>
                  </>
                ) : (
                  <>
                    <span>{new Date().getDate()}</span>
                    <span>{content.months[new Date().getMonth()]}</span>
                  </>
                )}
              </p>
            </div>
          </label>
        </div>
        {/* <div className="teaser_cont_form-normal_block">
          <label className="teaser_cont_form-normal_block_data">
            <span>
              <Img src={content.guestsImage} />
              {content.guestsName}
            </span>
            <div className="teaser_cont_form-normal_block_data_outside teaser_cont_form-normal_block_data_outside--after-none">
              <select {...bindGuestsCount} className="teaser_select">
                {numbersArray.map(item => (
                  <option key={Math.random()} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>
          </label>
        </div> */}

        <button className="general-button" type="submit">
          {content.formButton}
        </button>
        <input type="hidden" name="form-name" value="Volter" />
      </form>
    </>
  )
}
